export default __webpack_public_path__ + "static/media/bankVerificationhelp@2x.33842d5c.png";